module.exports = __webpack_public_path__ + "5e78042b1cdf3090758bb88b1efa8d69.svg";